import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class validacionRolService {

  constructor() { }

  validacionBotonVoBo(rol: string, estatus: string, opE: string, pantalla: string):any {
    // Validamos los campos que se pueden mostrar
    switch (rol) {
      case 'Supervisor del proyecto':
        if (opE === '1') {
          return true; // No se permite editar si opE es '1'
        }
        return false; // Permitir editar en otros casos
  
      case 'Administrador del proyecto':
        return true; // No se permite editar si opE es '1' y el estatus no es "VoBo"
  
      case 'Administrador':
        if (opE === '1' && estatus === 'Aclaracion') {
          return true; // No se permite editar si opE es '1' y el estatus es "Aclaración"
        }
        
        return false; // Permitir editar en otros casos
    }
  }


  validacionBotonEditar(rol: string, estatus: string, opE: string, pantalla: string):any {
    // Validamos los campos que se pueden mostrar
    switch (rol) {
      case 'Supervisor del proyecto':
        if (opE === '1') {
          return true; // No se permite editar si opE es '1'
        }
        return false; // Permitir editar en otros casos
  
      case 'Administrador del proyecto':
        if (opE === '1' && estatus !== 'VoBo') {
          return false; // No se permite editar si opE es '1' y el estatus no es "VoBo"
        }
        return true; // Permitir editar cuando esta en Aclaración o Pendiente
  
      case 'Administrador':
        if (opE === '1' && estatus === 'Aclaracion') {
          return true; // No se permite editar si opE es '1' y el estatus es "Aclaración"
        }
        
        return false; // Permitir editar en otros casos
    }
  }
  

  validacionCampos(rol: string, estatus: string, opE: string, pantalla: string):any{

    // Validamos los campos que se pueden mostrar
    switch (rol) {
      case 'Supervisor del proyecto':
        return false; //si es supervisor de proyecto debe estar en disabled
  
      case 'Administrador del proyecto':
        if(estatus === 'VoBo'){
          return false; //se ponen disabled los ipunt en VoBO
        }
      return true; // si es administrador de proyecto no se le coloca disabled
  
      case 'Administrador':
        if (estatus === 'Aclaracion') {
          return false; //se ponen disabled los ipunt en Aclaracion
        }
        return true; // Permitir editar en otros casos
    }
    
  }

}
